import { render, staticRenderFns } from "./OdSelect.vue?vue&type=template&id=5760b266&scoped=true"
import script from "./OdSelect.vue?vue&type=script&lang=js"
export * from "./OdSelect.vue?vue&type=script&lang=js"
import style0 from "./OdSelect.vue?vue&type=style&index=0&id=5760b266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760b266",
  null
  
)

export default component.exports